import {
  keepPreviousData,
  useInfiniteQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClientAccount } from '~/@api/client/useApiClientAccount'
import type {
  IPortfolioInvestmentsOkResponse,
  IPortfolioInvestmentsRequest,
} from '~/@api/generated-api-types-account/Api'
import {
  defaultPaginationParams,
  infiniteQueryNextPageParam,
} from '~/@mid_query/utils/pagination.utils'

type Filter = IPortfolioInvestmentsRequest['filter']
type Sort = IPortfolioInvestmentsRequest['sort']

type Props = {
  filter: Filter
  sort: Sort
}

export function useInvestmentsQuery({ filter, sort }: Props) {
  const queryClient = useQueryClient()
  const client = useApiClientAccount()

  async function fetchInvestments(args: IPortfolioInvestmentsRequest) {
    return client.account
      .portfolioControllerGetInvestments(args, {
        secure: true,
      })
      .then((resp) => resp.data)
  }

  return {
    query: useInfiniteQuery({
      queryKey: ['investments', filter, sort],
      queryFn: ({ pageParam = 0 }) =>
        fetchInvestments({
          ...defaultPaginationParams(pageParam),
          filter,
          sort,
        }),
      getNextPageParam:
        infiniteQueryNextPageParam<IPortfolioInvestmentsOkResponse>,
      initialPageParam: 0,
      // throwOnError: true,
      placeholderData: keepPreviousData,
    }),
    reloadInvestments: () =>
      queryClient.resetQueries({ queryKey: ['investments'] }),
  }
}
